import { Component, OnInit } from '@angular/core';
import { Station } from '../../models/station';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProductionPlannerService } from "../productionplanner.service";
@Component({
  selector: 'app-station',
  templateUrl: './productionuserattendance.component.html',
  styleUrls: ['../../home/home.component.css']
})
export class ProductionUserAttendanceComponent implements OnInit {
    isAttendanceList: boolean = true;
    UserAttendance: any[] = [];
    LoginDate: any = null;
    currentDate: any  = new Date();
    UserListForAttendance: any[] = [];
    IsCurrentDate: any = null;
    IsShowBTN: boolean = false;
    
    constructor(private _toastr: ToastrService, private productionPlannerService: ProductionPlannerService, private spinner: NgxSpinnerService){}

    ngOnInit(){
        this.UserListForAttendance = [];
        var year = new Date().getFullYear().toString().substr(0);
        var month = (new Date().getMonth() + 1).toString().substr(0);
        var date = new Date().getDate().toString().substr(0);

        var hours = new Date().getHours().toString().substr(0);
        var minutes = new Date().getMinutes().toString().substr(0);
        var seconds = new Date().getSeconds().toString().substr(0);
        if (month.length == 1) {
           month = 0 + month;
        }
        if (date.length == 1) {
           date = 0 + date;
        }
        if (hours.length == 1) {
           hours = 0 + hours;
        }
        if (minutes.length == 1) {
           minutes = 0 + minutes;
        }
        if (seconds.length == 1) {
           seconds = 0 + seconds;
        }
        this.IsCurrentDate = year + '-' + month + '-' + date;
        this.LoginDate = year + '-' + month + '-' + date;
        if(this.IsCurrentDate == this.LoginDate){
            this.IsShowBTN = true;
        } else{
            this.IsShowBTN = false;
        }
        this.getAllProductionUserPresence();
    }

    OnchangeLoginDate() {
        this.LoginDate.toLocaleDateString();
        var date = this.LoginDate.getFullYear() + '-' + (this.LoginDate.getMonth() + 1) + '-' + this.LoginDate.getDate();
        this.LoginDate = date;        
      }

    getAllProductionUserPresence(){
        if(this.LoginDate == null || this.LoginDate == "null" || this.LoginDate == ""){
            this._toastr.warning("Please select login date.");
        } else{
            this.spinner.show()
            this.productionPlannerService.getAllProductionUserPresence(this.LoginDate).subscribe((data: any) => {
                this.UserAttendance = [];
                this.UserAttendance = data;
                if(this.UserAttendance.length > 0){
                    this.isAttendanceList = true;
                } else{
                    this.isAttendanceList = false;
                }
                var year = new Date(this.LoginDate).getFullYear().toString().substr(0);
                var month = (new Date(this.LoginDate).getMonth() + 1).toString().substr(0);
                var date = new Date(this.LoginDate).getDate().toString().substr(0);
                if (month.length == 1) {
                    month = 0 + month;
                 }
                 if (date.length == 1) {
                    date = 0 + date;
                 }
                let matchingDT = year + '-' + month + '-' + date;
                if(this.IsCurrentDate == matchingDT){
                    this.IsShowBTN = true;
                } else{
                    this.IsShowBTN = false;
                }
                this.spinner.hide();      
            }, (err) => { 
                this._toastr.error(err); 
                this.spinner.hide(); 
            });
        }
    }

    AttendanceChecked(item){
        // Toggle the value of isLogin when the checkbox is clicked
        item.isLogin = !item.isLogin;
        // Check if the item exists in selectedItems array
        const index = this.UserListForAttendance.indexOf(item);
        if (index > -1) {
           // If item exists, remove it from the array
           this.UserListForAttendance.splice(index, 1);
           this.UserListForAttendance.push(item);
        } else {
          // If item doesn't exist, add it to the array
          this.UserListForAttendance.push(item);
        }
    }

    usersAttendance(){
        if(this.UserListForAttendance.length == 0){
            this._toastr.warning("Please select atleast one new user.")
        } else{
            let obj = {
                UserList: this.UserListForAttendance,
                UserId: localStorage.getItem('userid')
            }
            this.spinner.show()
            this.productionPlannerService.usersAttendance(obj).subscribe((data: any) => {
                if(data == true){
                    this._toastr.success("Save attendance successfully");
                    this.UserListForAttendance = [];
                    this.getAllProductionUserPresence();
                } else{
                    this._toastr.warning("Something went wrong please contact administration");
                }
                this.spinner.hide();      
            }, (err) => { 
                this._toastr.error(err); 
                this.spinner.hide(); 
            });
        }
    }

}